import './style.css';

import { openModal } from 'components/modal/modules/dispatcher/methods';
import { AppConfig } from 'config/app';
import { getCookie } from 'lib/utils/cookie';
// import { RouteTo } from 'lib/utils/routing';
import CreateCampaign from 'pages/campaign/CreateCampaign';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
	Collapse,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
	Nav,
	Navbar,
	NavItem,
	NavLink,
	UncontrolledDropdown,
} from 'reactstrap';
import { fetchGraphQL } from 'services/graphql/GraphQL';
import UIDucks from 'stores/ducks/UI.duck';
import UserDucks from 'stores/ducks/User.duck';
import UserSettings from './UserSettings';

interface IAppBarProps {
	isLoggedIn?: boolean;
	dispatch?: any;
	isOpen?: boolean;
	user: {
		avatar?: string;
		name?: string;
		lastname?: string;
		email?: string;
		stripeId?: string;
		id?: any;
		username?: any;
		isStripeStandard?: any;
	};
}
export class AppBar extends React.Component<IAppBarProps, { [label: string]: any }> {

	constructor(props) {
		super(props);
		this.renderUserItem = this.renderUserItem.bind(this);
		this.toggleNavBar = this.toggleNavBar.bind(this);
		this.getDashboardURL = this.getDashboardURL.bind(this);
		this.openUserSettingsModal = this.openUserSettingsModal.bind(this);
		this.openCreateCampaignModal = this.openCreateCampaignModal.bind(this);
		this.setUpStripe = this.setUpStripe.bind(this);
	}

	public getDashboardURL() {
		if (this.props.user.isStripeStandard) {
			window.location.href = 'https://dashboard.stripe.com'
		} else {
			fetchGraphQL(`
		  query {
			user {
			  getStripeDashboardURL(stripeId:"${this.props.user!.stripeId}")
			}
		  }
		`).then(response => {
				window.location = response.user.getStripeDashboardURL
			})
		}
	}

	public setUpStripe() {
		fetchGraphQL(`
		  mutation {
			user {
				setUpStripeStandard(email:"${this.props.user!.email}")
			}
		  }
		`).then(response => {
			if (response.user.setUpStripeStandard) {
				if (response.user.setUpStripeStandard === 'error') {
					alert('Something went wrong. Please reach out to support.')
				} else {
					window.location.href = response.user.setUpStripeStandard
				}
			}
		})
	}

	public toggleNavBar(e?: any) {
		this.props.dispatch(UIDucks.setNavBar(!this.props.isOpen));
	}

	public openUserSettingsModal() {
		const content = <UserSettings />
		openModal(content, this.props.user!.username, [])
	}

	public openCreateCampaignModal() {
		const content = <CreateCampaign />
		openModal(content, "NEW EVENT", [])
	}

	public renderUserItem() {
		if (this.props.isLoggedIn) {
			if (this.props.user && this.props.user.avatar) {
				return (
					<UncontrolledDropdown nav={true} inNavbar={true} style={{ paddingBottom: '0px', height: '100%', textAlign: 'right' }}>
						<DropdownToggle nav={true} caret={true}>
							<img src={this.props!.user!.avatar} width='30px' height='30px' style={{
								objectFit: 'cover',
								borderRadius: '50%'
							}} />
						</DropdownToggle>
						<DropdownMenu right={true} style={{ textAlign: 'left', width: '120px' }}>
							<DropdownItem style={{ textAlign: 'left' }} onClick={() => this.openUserSettingsModal()}>
								Profile
							</DropdownItem>
							<Link to='/logout'>
								<DropdownItem style={{ textAlign: 'left' }}>
									Logout
								</DropdownItem>
							</Link>
						</DropdownMenu>
					</UncontrolledDropdown>
				);
			} else {
				return (
					<UncontrolledDropdown nav={true} inNavbar={true} style={{ padding: '0px', height: '100%' }}>
						<DropdownToggle nav={true} caret={true} style={{ color: '#1931b9', textAlign: 'right', fontSize: '14px', fontWeight: 'bold', fontStyle: 'bold' }}>
							{this.props.user!.username}
						</DropdownToggle>
						<DropdownMenu right={true} style={{ textAlign: 'left', width: '120px' }}>
							<DropdownItem style={{ textAlign: 'left' }} onClick={() => this.openUserSettingsModal()}>
								Profile
							</DropdownItem>
							<Link to='/logout'>
								<DropdownItem style={{ textAlign: 'left' }}>
									Logout
								</DropdownItem>
							</Link>
						</DropdownMenu>
					</UncontrolledDropdown>
				);
			}
		}
		if (!getCookie("token")) {
			return (
				<NavItem>
					<Link to='/login'>
						<NavLink
							// onClick={this.toggleNavBarOverview}
							className="sexyBlack"
						>
							LOGIN
						</NavLink>
					</Link>
				</NavItem>
			);
		}
	}

	public render() {

		const url = window.location.href.toLowerCase();
		const urlItems = url.split('/')
		const subdomain = urlItems[2].split('.')[0]

		if (subdomain !== 'app' && subdomain !== 'localhost:3000' && subdomain !== 'test') {
			return null;
		}

		if (window.location.pathname === '/login'
			|| window.location.pathname === '/login/'
			|| window.location.pathname === '/logout'
			|| window.location.pathname === '/'
			|| window.location.pathname === '/signup'
			|| window.location.pathname.includes('/receipt/')
			|| window.location.pathname.includes('/setup/')
			|| window.location.pathname.includes('/sell/')
			|| window.location.pathname.includes('/showcase/')) {
			return null;
		}

		const logo = require('./Dark-logo-copy.png');

		return (
			<div key={window.location.pathname}>
				<Navbar className='sticky-top' expand='xl'
					style={{
						maxHeight: screen.width >= 1200 ? '50px' : 'auto',
						overflow: 'visible',
						marginTop: screen.width >= 768 ? '10px' : 'none',
						marginBottom: screen.width >= 768 ? '5px' : 'none',
						fontSize: '15px',
					}}>
					<div className="container">
						<a href={
							this.props.user === undefined
								|| this.props.user.id === undefined
								|| this.props.user.id === null
								|| this.props.user.id === ""
								? AppConfig.hostUrl + '/' : AppConfig.hostUrl + '/campaigns'
						} style={{ alignContent: 'center' }}>
							{
								window.location.href.includes('/campaign/') ?
									<h2 style={{ height: '100%', lineHeight: '100%', alignContent: 'center', paddingLeft: '11px' }}>
										←
									</h2>
									: <img src={logo} height="50px" style={{ paddingRight: '10px', paddingLeft: screen.width >= 768 ? '0px' : '20px' }} />
							}
						</a>
						<button
							className={
								this.props.isOpen
									? 'navbar-toggler animated-burger navbar-toggler-right menu-button'
									: 'navbar-toggler animated-burger navbar-toggler-right collapsed menu-button'
							}
							type='button'
							data-toggle='collapse'
							data-target='#collapsingNavbar'
							onClick={this.toggleNavBar}
						>
							<span />
							<span />
							<span />
						</button>

						<Collapse isOpen={this.props.isOpen} navbar={true} style={{ width: 'auto' }}>
							<div className="big-split-1200" style={{ float: 'right', paddingLeft: '15px', marginTop: 10, marginBottom: 10 }}>
								<Nav className='ml-auto' navbar={true} style={{ paddingTop: '0 auto', paddingBottom: '0 auto', paddingight: '0 auto', float: 'right' }}>
									{
										this.props.isLoggedIn ?
											<>
												<div style={{ width: '225px', textAlign: 'center', paddingTop: '0 auto', paddingBottom: '0 auto', marginRight: '7px' }}>
													<NavItem style={{ width: '100%', cursor: 'pointer' }}>
														<a href={'/showcase/' + this.props.user.username} target='_blank' >
															<div className={"new-button-outline"} style={{ lineHeight: '45px', color: '#1931b9', width: '225px' }}>
																Showcase All Events
															</div>
														</a>
													</NavItem>
												</div>
												<div style={{ width: '160px', textAlign: 'center', paddingTop: '0 auto', paddingBottom: '0 auto', marginRight: '7px' }}>
													<NavItem style={{ width: '100%', cursor: 'pointer' }} onClick={() => this.openCreateCampaignModal()}>
														<div className={"new-button-outline"} style={{ lineHeight: '45px' }}>
															New Event
														</div>
													</NavItem>
												</div>
												{
													this.props.user!.id === '5d3a0a1f7634d34b1a554849' ? null :
														<div style={{ width: '160px', textAlign: 'center', paddingTop: '0 auto', paddingBottom: '0 auto', marginRight: '7px' }}>
															<NavItem style={{ width: '100%' }}>
																{
																	this.props.user!.stripeId !== undefined && this.props.user!.stripeId !== null ?
																		<div style={{ textAlign: 'center', cursor: 'pointer', lineHeight: '45px' }} className="new-button-outline" onClick={this.getDashboardURL}>
																			Payouts
																		</div>
																		:
																		<div style={{ textAlign: 'center', cursor: 'pointer', lineHeight: '45px' }} className="new-button-outline" onClick={this.setUpStripe}>
																			Set Up Payouts
																		</div>
																}
															</NavItem>
														</div>
												}
											</> : null
									}
									<div style={{ width: '160px', textAlign: 'center', paddingTop: '0 auto', paddingBottom: '0 auto' }}>
										{this.renderUserItem()}
									</div>
								</Nav>
							</div>
							<div className="small-split-1200" style={{ float: 'right' }}>
								<Nav className='ml-auto' navbar={true} style={{ paddingTop: '0 auto', paddingBottom: '0 auto', paddingight: '0 auto', float: 'right' }}>
									{
										this.props.isLoggedIn ?
											<div>
												<div style={{ width: '225px', textAlign: 'center', paddingTop: '0 auto', paddingBottom: '0 auto' }}>
													<NavItem>
														<a href={'/showcase/' + this.props.user.username} target='_blank' >
															<div style={{ color: '#1931b9', textDecoration: 'underline' }}>
																<NavLink>Showcase All Events</NavLink>
															</div>
														</a>
													</NavItem>
												</div>
												<div style={{ width: '160px', textAlign: 'center', paddingTop: '0 auto', paddingBottom: '0 auto' }}>
													<NavItem onClick={() => this.openCreateCampaignModal()}>
														<div className='sexyBlack'>
															<NavLink>New Event</NavLink>
														</div>
													</NavItem>
												</div>
												<div style={{ width: '160px', textAlign: 'center', paddingTop: '0 auto', paddingBottom: '5px' }}>
													<NavItem>
														{
															this.props.user!.stripeId !== undefined && this.props.user!.stripeId !== null ?
																<div className="sexyBlack">
																	<NavLink onClick={this.getDashboardURL}>
																		Payouts
																	</NavLink>
																</div>
																:
																<div className="sexyBlack">
																	<NavLink onClick={this.setUpStripe}>
																		Set Up Payouts
																	</NavLink>
																</div>
														}
													</NavItem>
												</div>
											</div>
											: null
									}
									<div style={{ width: '150px', textAlign: 'right', paddingTop: '0 auto', paddingBottom: '0 auto' }}>
										{this.renderUserItem()}
										{
											this.props.isOpen ?
												<div><br /><br /></div> :
												null
										}
									</div>
								</Nav>
							</div>
							<p />
						</Collapse>
					</div>
				</Navbar>
			</div >
		);
	}

}

const mapStateToProps = state => ({
	isLoggedIn: UserDucks.isAuthenticated(state),
	isOpen: UIDucks.getIsNavBarOpen(state),
	user: UserDucks.getUser(state)
});

export default connect(mapStateToProps)(AppBar);



// WEBPACK FOOTER //
// ./src/components/common/controls/navbar/AppBar.tsx